/**
 * Performance payloads come back as an empty object for smartfolios that have
 * no computed history yet — Private Equity in particular. Coercing those
 * missing values for display rendered "NaN%", so these helpers let callers
 * tell "no data" apart from a real 0 and hide the performance UI instead.
 */
export const toPerformanceNumber = (value: any): number | null => {
  if (value === null || value === undefined || value === "") return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const hasPerformanceData = (
  performances?: Record<string, any> | null,
  keys?: string[],
): boolean => {
  if (!performances) return false;
  const values = keys
    ? keys.map((key) => performances[key])
    : Object.values(performances);
  return values.some((value) => toPerformanceNumber(value) !== null);
};
